import classNames from 'classnames';
import React, { FC } from 'react';
import Lottie from 'react-lottie';
import * as animationData from '@ui-kit/lottie/loader.json';
import styles from '../styles/loader.module.scss';

type PropsType = {
  height?: number;
  width?: number;
  children?: never;
  className?: string;
};

export const Loader: FC<PropsType> = ({
  height = 300,
  width = 300,
  className,
}: PropsType) => {
  return (
    <div className={classNames(className, styles.loaderContainer)}>
      <div className={styles.loader}>
        <LoadingIcon height={height} width={width} />
      </div>
    </div>
  );
};

export const LoadingIcon = (props: { width: number; height: number }) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: (animationData as any).default,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <Lottie
      options={defaultOptions}
      height={props.height}
      width={props.width}
    />
  );
};
